import ApiService from '../api.service'
import { Abono } from './abono'
import { Afastamento } from './afastamentos'
import { LogCalculos } from './calculo'
import { CompensacaoManual } from './compensacao-manual'
import { DescontoDSRFuncionario, DSR } from './dsr'
import { Escalas } from './escalas'
import { FaltaCadastrada } from './faltas-cadastradas'
import { CompensacaoDia } from './feriados'
import { FeriadosCliente } from './feriados-cliente'
import { Registro } from './registros'
import { Sobreaviso } from './sobreaviso'
import { TabelaHorarios } from './tabela-horarios'
import { TrocaDiaTrabalho } from './troca-horarios'

export interface JornadaDiaria {
    id: number
    nome: string
    empresaId: number
    dia: string
    funcionarioId: number
    registros: Registro[]
    tabelaHorario?: TabelaHorarios[]
    isAtivo: boolean

    troca?: TrocaDiaTrabalho
    abono?: Abono
    afastamento?: Afastamento
    compensacao?: CompensacaoDia
    compensacaoManual?: CompensacaoManual
    sobreaviso?: Sobreaviso
    feriado?: FeriadosCliente
    DSR?: DSR
    trabalhaNoDia: boolean
    faltaCadastrada?: FaltaCadastrada
    folga?: any
    escala?: Escalas
    descontoDsr: DescontoDSRFuncionario
    logs?: LogCalculos[]

    horasExtra?: string
    horasTrabalhadas?: string
    faltas?: string
    /** Justificativa da edição manual do dia (feature #1522) */
    justificativa?: string | null
    /** Horas extras por porcentagem da regra de cálculo: { '50': '01:00' } */
    porcentagemHrsExtras?: Record<string, string>
}

export type JornadaDiariaQuery = {
    empresaId: number
    dia: string
    /** recorte do escopo; centro de custo e local se somam (interseção) */
    centroCustoIds?: number[]
    locaisIds?: number[]
}

export type JornadaMensal = Omit<JornadaDiaria, 'id' | 'nome' | 'empresaId'>

export type JornadaMensalQuery =
    | {
          funcionarioId: number
          organizar: boolean
          competencia: string
      }
    | {
          funcionarioId: number
          organizar: boolean
          dataInicial: string
          dataFinal: string
      }

export const jornada = {
    mensal: new ApiService<null, JornadaMensal, JornadaMensalQuery>('jornada'),
    diaria: new ApiService<null, JornadaDiaria, JornadaDiariaQuery>('jornada'),
}
